import { render, staticRenderFns } from "./UseNoticeForUserPage.vue?vue&type=template&id=f8a60958&scoped=true"
import script from "./UseNoticeForUserPage.vue?vue&type=script&lang=js"
export * from "./UseNoticeForUserPage.vue?vue&type=script&lang=js"
import style0 from "./UseNoticeForUserPage.vue?vue&type=style&index=0&id=f8a60958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a60958",
  null
  
)

export default component.exports